import React from "react";
import PropTypes from "prop-types";

// hooks
import { useIosInputFocusLightBox } from "frontend/context/DevicesContext/implementations/IOSInputIsFocusedContext/useIosInputFocusLightBox.js";

// components
import CoreSearchBar from "../../index";
import DropDownAndInput from "../../components/DropDownAndInput";
import SearchButton from "../../components/SearchButton";

// component
export const SearchBar = props => {
    const { id = "header-search", isDarkMode } = props;
    const { onFocus } = useIosInputFocusLightBox();

    return (
        <CoreSearchBar {...props} id={id} isInSiteHeader inputOnFocus={onFocus}>
            <DropDownAndInput />
            <SearchButton isDarkMode={isDarkMode} />
        </CoreSearchBar>
    );
};

export default SearchBar;

// prop-types
SearchBar.propTypes = {
    id: PropTypes.string,
    isDarkMode: PropTypes.bool
};
